import { useEffect } from "react";
import { CategoryType, ProductType } from "../../types";
import { fetchJson } from "../../utils";
import { useAppState } from "../../context";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import CardBlock from "../../pages/catalog/CardBlock";
import useWishList from "../../pages/wishlist/useWishList";
import useCart from "../../pages/cart/useCart";

type PopularVideoStoriesProps = {
    exclude?: number[]; // Array of product IDs to exclude
    categories?: CategoryType[];
    limit?: number;
};

const PopularVideoStories = ({ exclude = [], categories = [], limit = 9 }: PopularVideoStoriesProps) => {
    const [products, setProducts] = useAppState<ProductType[]>('popular-products', []);
    const { isInWishlist } = useWishList();
    const { findCartItem } = useCart();

    let fetchUrl = '/api/catalog/popular?';
    if (categories.length > 0) {
        fetchUrl = `${fetchUrl}categories=${categories.join(',')}`;
    }
    if (limit) {
        fetchUrl = `${fetchUrl}&limit=${limit}`;
    }
    useEffect(() => {
        fetchJson<ProductType[]>(fetchUrl)
        .then(({json}) => {
            setProducts(json);
        });
    }, []);

    // Filter out excluded products
    const filteredProducts = products.filter(product => !exclude.includes(product.id));

    if (filteredProducts.length === 0) return null;

    return (
        <section className="section s-more">
            <div className="inside-wrapper">
                <h2 className="section__title">
                    Popular video stories 
                </h2>
                <Swiper
                    className="s-more__slider slider swiper js_swiper_more"
                    modules={[Navigation]}
                    slidesPerView={1}
                    spaceBetween={0}
                    resistanceRatio={0}
                    watchSlidesProgress={true}
                    loop={true}
                    speed={500}
                    navigation={{
                        prevEl: '.slider__arrow_prev',
                        nextEl: '.slider__arrow_next'
                    }}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                        },
                        1024: {
                            slidesPerView: 3,
                        }
                    }}
                >
                    {filteredProducts.map((product) => (
                        <SwiperSlide key={product.id} className="s-more__slide">
                            <CardBlock 
                                {...product}
                                onWishlist={isInWishlist(product)}
                                inCart={!!findCartItem(product)}
                            />
                        </SwiperSlide>
                    ))}

                    <div className="slider__controls">
                        <button className="slider__arrow slider__arrow_prev"></button>
                        <button className="slider__arrow slider__arrow_next"></button>
                    </div>
                </Swiper>
            </div>
        </section>
    );
}

export default PopularVideoStories; 